import { render } from "./JobBoardCard.vue?vue&type=template&id=8bd793ba&scoped=true&ts=true"
import script from "./JobBoardCard.vue?vue&type=script&lang=ts"
export * from "./JobBoardCard.vue?vue&type=script&lang=ts"

import "./JobBoardCard.vue?vue&type=style&index=0&id=8bd793ba&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bd793ba"]])

export default __exports__